module.exports = __webpack_public_path__ + "media/promo/hochland/images/test_m-a99770f550b9b9700ace76013347ba03.png";